export default "__VITE_ASSET__CXkN3opK__"